import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/processes')({
  head: () => ({
    meta: [{ title: 'Processes | Tekst' }],
  }),
  component: () => <Outlet />,
});
